var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.97 26.33C29.97 26.69 29.89 27.06 29.72 27.42C29.55 27.78 29.33 28.12 29.04 28.44C28.55 28.98 28.01 29.37 27.4 29.62C26.8 29.87 26.15 30 25.45 30C24.43 30 23.34 29.76 22.19 29.27C21.04 28.78 19.89 28.12 18.75 27.29C17.6 26.45 16.51 25.52 15.47 24.49C14.44 23.45 13.51 22.36 12.68 21.22C11.86 20.08 11.2 18.94 10.72 17.81C10.24 16.67 10 15.58 10 14.54C10 13.86 10.12 13.21 10.36 12.61C10.6 12 10.98 11.44 11.51 10.94C12.15 10.31 12.85 10 13.59 10C13.87 10 14.15 10.06 14.4 10.18C14.66 10.3 14.89 10.48 15.07 10.74L17.39 14.01C17.57 14.26 17.7 14.49 17.79 14.71C17.88 14.92 17.93 15.13 17.93 15.32C17.93 15.56 17.86 15.8 17.72 16.03C17.59 16.26 17.4 16.5 17.16 16.74L16.4 17.53C16.29 17.64 16.24 17.77 16.24 17.93C16.24 18.01 16.25 18.08 16.27 18.16C16.3 18.24 16.33 18.3 16.35 18.36C16.53 18.69 16.84 19.12 17.28 19.64C17.73 20.16 18.21 20.69 18.73 21.22C19.27 21.75 19.79 22.24 20.32 22.69C20.84 23.13 21.27 23.43 21.61 23.61C21.66 23.63 21.72 23.66 21.79 23.69C21.87 23.72 21.95 23.73 22.04 23.73C22.21 23.73 22.34 23.67 22.45 23.56L23.21 22.81C23.46 22.56 23.7 22.37 23.93 22.25C24.16 22.11 24.39 22.04 24.64 22.04C24.83 22.04 25.03 22.08 25.25 22.17C25.47 22.26 25.7 22.39 25.95 22.56L29.26 24.91C29.52 25.09 29.7 25.3 29.81 25.55C29.91 25.8 29.97 26.05 29.97 26.33Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9e11563d83613c1b9a86a47959b1d45d.svg";
export { ForwardRef as ReactComponent };